import * as trace from 'owa-trace';
import BaseItemId from 'owa-service/lib/contract/BaseItemId';
import EventScope from 'owa-service/lib/contract/EventScope';
import ItemChange from 'owa-service/lib/contract/ItemChange';
import updateCalendarEventOperation from 'owa-service/lib/operation/updateCalendarEventOperation';
import updateCalendarEventRequest from 'owa-service/lib/factory/updateCalendarEventRequest';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { MailboxInfo } from 'owa-client-ids';
import getMailboxRequestOptions from 'owa-service-utils/lib/getMailboxRequestOptions';

/**
 * Makes the UpdateCalendarEvent call to the server and returns the response
 * @param singleOrSeriesId id of the CalendarEvent that needs to be updated (single or series)
 * @param mailboxInfo The mailbox info the user
 * @param itemChange the set of properties that changed and will be sent to the server
 * @param eventScope The scope of the update call to the event
 */
export default async function updateCalendarEventService(
    singleOrSeriesId: BaseItemId,
    mailboxInfo: MailboxInfo,
    itemChange: ItemChange,
    eventScope: EventScope
): Promise<UpdateItemResponseMessage> {
    try {
        const request = updateCalendarEventRequest({
            EventId: singleOrSeriesId,
            ItemChange: itemChange,
            EventScope: eventScope,
        });

        const response = await updateCalendarEventOperation(
            {
                Header: getJsonRequestHeader(),
                Body: request,
            },
            getMailboxRequestOptions(mailboxInfo)
        );

        return response.Body.ResponseMessages.Items[0] as UpdateItemResponseMessage;
    } catch (error) {
        trace.errorThatWillCauseAlert(
            'Calendar event update service request failed: ' + error.Message
        );
        return null;
    }
}
